export const createBlob = async (src: string) => {
  const response = await fetch(src, {cache: 'no-cache'});
  const blob = await response.blob();
  return blob;
};
